<template>
  <div class="award">
    <div
      class="flex-box flex-hv-c bb"
      style="padding-left: 10px;"
      @click="sortSwitch"
      v-show="list.length>0"
    >
      <div class="flex-box flex-v-c sort" style="height: 0.8rem;">
        <span v-if="type==1">现金</span>
        <span v-else>类型</span>
        <i class="iconfont" :class="{iconXiajiantou:!sortListShow,iconShangjiantou:sortListShow}"></i>
      </div>
    </div>
    <Cloadmore @loadBottom="loadBottom" @loadTop="loadTop" ref="listTopic">
      <ul v-if="list.length>0" v-cloak>
        <li v-for="(item,index) in list" :key="index" class="bb">
          <div class="flex-box">
            <div class="flex2 flex-box flex-d-c flex-h-c">代理：{{item.nickname}} ({{item.id}})</div>
            <div
              class="flex1 flex-box flex-v-c flex-h-e"
              :class="{success:item.statue!=-1,failure:item.statue==-1}"
            >{{item.errMsg}}</div>
            <div class="flex1">
              <div class>类型：{{item.type}}</div>
            </div>
          </div>
          <div class="flex-box flex-v-c">
            获得奖励：
            <span class="amColor">
              <i class="iconfont icon-rmb" v-if="item.type=='现金'"></i>
              {{item.amount}}
            </span>
          </div>
          <div class="flex-box flex-v-c">奖励原因：{{item.reason}}</div>
          <div class="flex-box flex-v-c flex-h-e time">{{item.deliveryTime | formatDate}}</div>
        </li>
      </ul>
      <div v-else class="nullData">暂无数据~</div>
    </Cloadmore>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue';
export default {
  name: 'memberAward',
  components: { Cloadmore },
  data: function () {
    return {
      type: '',
      loader: false,
      list: [],
      pageNum: 10,
      index: 1,
      dataLength: '',
      sortListShow: false//控制显示隐藏
    }
  },
  methods: {
    getData(params) {
      var that = this
      var data = {
        pageNum: this.pageNum,
        index: this.index
      }
      if (that.type) {
        data.type = 1
      }

      this.$http.get('/member/memberAwardRecord', {
        params: data
      }).then(function (res) {
        if (res.code == 0) {
          that.loader = true;

          that.dataLength = res.data.list.length;
          console.log(res.data.list.length)
          if (that.dataLength > 0) {
            for (let i = 0; i < that.dataLength; i++) {
              res.data.list[i].deliveryTime = that.$common.common.formatDate(res.data.list[i].deliveryTime)
              that.list.push(res.data.list[i])
            }

            if (params == 'getNewData') {//下拉 刷新 或者 搜索 时  获取新数据 避免使用清空数组造成的闪屏
              for (let i = 0; i < that.dataLength; i++) { //新数据有多少条
                that.list[i] = res.data.list[i]
              }
              that.list.length = that.dataLength;//截取数组长度
            }
          } else {
            that.$refs.listTopic.setAllLoaded(true) //关闭上拉加载

            that.$toast({
              message: '没有更多数据', position: 'bottom',
            });
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    loadTop() {
      let that = this
      that.index = 1
      that.getData('getNewData')
      setTimeout(function () {
        that.$refs.listTopic.onTopLoaded();
      }, 1000)
      that.$refs.listTopic.setAllLoaded(false) //调用子组件loadmore的函数 开启上拉加载
    },

    loadBottom() {
      let that = this;
      if (!this.loader) {
        return
      }
      that.index += 1
      setTimeout(function () {
        that.$refs.listTopic.onBottomLoaded();
      }, 1000)
      that.getData()
    },
    sortSwitch() {
      let that = this;
      this.sortListShow = !this.sortListShow
      if (this.sortListShow) {
        that.type = 1
      } else {
        that.type = ''
      }
      that.getData('getNewData')
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.title {
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    #f4f6f6 0%,
    #e4e5e5 22%,
    #d7dbdb 50%,
    #e4e5e5 80%,
    #f4f6f6 100%
  );
}

.icon-rmb {
  font-size: 0.3rem;
}

ul {
  li {
    line-height: 1.5;
    padding: 10px;
    min-height: 1.2rem;
  }
}

.sort .iconfont {
  font-size: 0.1rem;
  margin-top: 2px;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/memberAward/index.vue